import { useEffect, useState } from 'react';
import debounce from 'lodash-es/debounce';
interface WindowSize {
	width: number | null;
	height: number | null;
}

/**
 * Reusable hook for handling window resize.
 *
 * @export
 * @returns
 */
export default function useWindowSize() {
	const [windowSize, setWindowSize] = useState<WindowSize>({
		width: null,
		height: null,
	});

	const executeResizeDebounced = debounce(update, 50);

	function update() {
		setWindowSize({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	}

	function handleResize() {
		executeResizeDebounced();
	}

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		handleResize();

		return () => window.removeEventListener('resize', handleResize);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return windowSize;
}
